import { postalCodeRegex } from "@homeinstead/shared";
import { z } from "zod";

export const postalCode = z.string().regex(postalCodeRegex, {
  error: "Postal code must be a valid US ZIP or Canadian postal code",
});
